import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import React, { useContext } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { CompraContext } from '../../CompraContext';
import { compraModais } from '../modal/compraModais';

const CompraFab = ({ onDelete }) => {
  const [, setModal] = useContext(CompraContext).modal;
  const [search] = useContext(CompraContext).search;
  const [selecao] = useContext(CompraContext).selecao;
  const [tipoSelecao] = useContext(CompraContext).tipoSelecao;
  const [, setCompraAtual] = useContext(CompraContext).compraAtual;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = (modal) => {
    setCompraAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: search, tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.compra().excluir && existeSelecionados,
      onClick: triggerDelete,
    },
    /*{
      icon: <CloudUploadIcon />,
      name: 'importarPlanilha',
      tooltip: 'Importar planilha',
      show: permissaoUtils.compra().cadastrar,
      onClick: () => console.log('Importar planilha'),

    }, */
    //   {
    // icon: <CloudUploadIcon />,
    // name: 'importarXMLDaNF',
    // tooltip: 'Importar XML da NF',
    // show: permissaoUtils.compra().cadastrar,
    // onClick: () => console.log('Importar XML da NF'),
    // },
    {
      icon: <ServicoIcon color="#fff" size={17} />,
      name: 'createCompraServico',
      tooltip: 'Comprar serviço',
      show: permissaoUtils.compra().cadastrar,
      onClick: () => triggerCreate(compraModais.comprarServico),
    },
    {
      icon: <FaShoppingCart />,
      name: 'createCompraProduto',
      tooltip: 'Comprar produto',
      show: permissaoUtils.compra().cadastrar,
      onClick: () => triggerCreate(compraModais.comprarProduto),
    },
  ];

  return <TableActions className={'stepFabButton'} actions={actions} />;
};

export default CompraFab;
